var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.239,
    height: 135.532,
    viewBox: "0 0 141.239 135.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OPG_account-icon",
    transform: "translate(-60.121 -93.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-line--inject-60",
    transform: "translate(86.46 182.559)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "freepik--table-line--inject-60-2",
    "data-name": "freepik--table-line--inject-60",
    y1: 30.066,
    x2: 78.618,
    transform: "translate(0)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-60",
    transform: "translate(73.525 170.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--plant--inject-60-2",
    "data-name": "freepik--plant--inject-60",
    d: "M111.51,321.893h.035l-3.338,1.941v-8.325l1.374-.962,4.37-2.969a9.2,9.2,0,0,0,9.314-7.192c-9.765-.559-9.862,5.822-9.8,7.005l-5.259,3.679v-6.462h.019s8.348-2.534-.136-15.058c0,0-8.977,11.837-.256,14.926V321.9l-3.563-2.717c.062-1.327-.144-8.073-10.762-7.642,0,0,4.091,10.246,10.541,7.941l1.009.776,2.717,2.057a.185.185,0,0,0,.066.019v4.692l-5.7-.066,2.4,14.441,6.912-.206L113.7,327.1l-5.5-.066v-2.744l3.838-2.239c6.45,1.68,10.277-4.657,10.277-4.657C111.65,315.458,111.51,321.893,111.51,321.893Z",
    transform: "translate(-93.51 -293.55)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-60",
    transform: "translate(110.302 203.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-60-2",
    "data-name": "freepik--coffee--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M202.693,410.649c0,1.3-3.148,2.348-7.036,2.348s-7.036-1.052-7.036-2.348,3.151-2.329,7.036-2.329S202.693,409.36,202.693,410.649Z",
    transform: "translate(-188.62 -396.373)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M188.62,414.32a31.968,31.968,0,0,0,1.389,7.731c1.129,2.953,6.027,3.966,8.69,2.783,1.975-.877,2.973-3.555,3.493-5.985",
    transform: "translate(-188.62 -400.044)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M217.772,425.484c.361.92,1.661.931,2.472.838a2.907,2.907,0,0,0,2.748-2.833,5.092,5.092,0,0,0-.854-3.167,2.818,2.818,0,0,0-2.216-1.1,1.432,1.432,0,0,0-1.417,1.692.866.866,0,0,0,.21.45c.357.388.869.163,1.3.33a1.432,1.432,0,0,1,.776.986,1.794,1.794,0,0,1-.14,1.684,1.223,1.223,0,0,1-1.164.411c-.388-.05-.714-.388-1.118-.388a.66.66,0,0,0-.66.714A1.087,1.087,0,0,0,217.772,425.484Z",
    transform: "translate(-206.417 -403.043)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 6.411,
    cy: 1.634,
    rx: 6.411,
    ry: 1.634,
    transform: "translate(0.66 13.247)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M201.931,388.245a2.426,2.426,0,0,1-.1-1.339,3.1,3.1,0,0,1,1.494-1.777,13.972,13.972,0,0,0,2-1.289,2.154,2.154,0,0,0,.776-2.115,8.813,8.813,0,0,0-.671-1.25,2.166,2.166,0,0,1,.264-2.3,1.847,1.847,0,0,1,2.22-.423,1.611,1.611,0,0,1,.617,2.111c-.248.435-.7.71-.99,1.122a1.793,1.793,0,0,0,0,1.972c.295.431.776.741.939,1.242a1.343,1.343,0,0,1-.528,1.374,2.782,2.782,0,0,1-1.455.493,7.515,7.515,0,0,0-1.552.206,2.391,2.391,0,0,0-1.164,3.772c.291.369.023.159-.435-.1A3.233,3.233,0,0,1,201.931,388.245Z",
    transform: "translate(-196.672 -377.547)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M201.939,388.23a2.391,2.391,0,0,1-.1-1.339,3.1,3.1,0,0,1,1.494-1.778,14.509,14.509,0,0,0,2-1.288,2.146,2.146,0,0,0,.776-2.115,8.09,8.09,0,0,0-.671-1.25,2.158,2.158,0,0,1,.268-2.3,1.836,1.836,0,0,1,2.22-.423,1.611,1.611,0,0,1,.617,2.111c-.252.435-.706.71-.99,1.122a1.778,1.778,0,0,0,0,1.972c.295.431.776.741.935,1.242a1.335,1.335,0,0,1-.524,1.37,2.779,2.779,0,0,1-1.459.5,7.827,7.827,0,0,0-1.552.2,2.4,2.4,0,0,0-1.164,3.776c.295.369.023.159-.435-.1A3.221,3.221,0,0,1,201.939,388.23Z",
    transform: "translate(-196.676 -377.537)",
    fill: "#fff",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-60",
    transform: "translate(60.85 99.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-60-2",
    "data-name": "freepik--window--inject-60",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    y1: 70.774,
    transform: "translate(96.727 7.32)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y1: 70.332,
    transform: "translate(42.31)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 120.517,
    transform: "translate(1.498 39.373)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.021
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 1.642,
    y2: 1.11,
    transform: "translate(55.285 25.009)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.525
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x1: 25.483,
    y2: 17.302,
    transform: "translate(0 45.92)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x1: 6.167,
    y2: 4.184,
    transform: "translate(16.556 43.502)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.05
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-60",
    transform: "translate(167.789 93.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-60-2",
    "data-name": "freepik--clock--inject-60",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 13.487,
    cy: 13.487,
    r: 13.487,
    transform: "translate(0 26.618) rotate(-80.69)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 10.692,
    cy: 10.692,
    r: 10.692,
    transform: "translate(4.791 4.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M376.629,132.07a.9.9,0,1,1-.9-.9A.9.9,0,0,1,376.629,132.07Z",
    transform: "translate(-360.245 -116.581)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    y1: 8.791,
    transform: "translate(15.615 6.963)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.137
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x1: 2.041,
    y1: 6.823,
    transform: "translate(13.438 8.531)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.137
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-60",
    transform: "translate(98.415 104.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-60-2",
    "data-name": "freepik--character--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M170.841,278.069l-12.19-48a4.459,4.459,0,0,1,2.457-5.154c10.813-4.941,29.108-10.238,43.429-10.021A4.467,4.467,0,0,1,208.918,219l3.144,39.664a4.471,4.471,0,0,1-2.81,4.51Z",
    transform: "translate(-158.512 -179.292)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M170.841,278.069l-12.19-48a4.459,4.459,0,0,1,2.457-5.154c10.813-4.941,29.108-10.238,43.429-10.021A4.467,4.467,0,0,1,208.918,219l3.144,39.664a4.471,4.471,0,0,1-2.81,4.51Z",
    transform: "translate(-158.512 -179.292)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M253.081,388.7l21.858-9.264a1.164,1.164,0,0,0,.229-2.03l-8.608-6.21a1.192,1.192,0,0,0-1.1-.147l-22.343,8.465a1.164,1.164,0,0,0-.3,2.022l9.1,7.013A1.164,1.164,0,0,0,253.081,388.7Z",
    transform: "translate(-209.812 -274.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M282.064,378s6.986,1,7.8,4.816-14.717,3.955-16.079,1.091S279.747,378,282.064,378Z",
    transform: "translate(-228.945 -279.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M245.877,362.977s-1.125-5.352-4.316-6.3-10.615.132-10.615.132L215.5,347.74l-9.92,6.831,4.4,1.785-.035.054s.722.276,1.89.7l2.577,1.048.116-.093c4.025,1.393,9.749,3.213,13.1,3.582a9.748,9.748,0,0,0,4.172,2.546,5.451,5.451,0,0,0,2.115.089,3.718,3.718,0,0,1,2.717.043c1.079.45,4.715,2.15,5.6,1.68s-.47-1.995-2.942-3.388a50.044,50.044,0,0,0,5.981,1.483c1.036,0,1.44-.179,1.393-.388Z",
    transform: "translate(-187.313 -260.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M213.444,359.16l15.7,8.115a7.19,7.19,0,0,0,3.8,2.527,11.09,11.09,0,0,0,2.461.035,9.858,9.858,0,0,1,7.23,3.031,2.712,2.712,0,0,1-1.622-.272c-1.048-.435-3.768-2.329-6.07-1.343s-6.287-2.635-6.287-2.635-16.168-3.349-21.4-6.838Z",
    transform: "translate(-188.334 -267.574)",
    fill: "#c9d6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M289.31,380.631s7.323,2.717,8.278,2.038-3.054-2.911-7.417-4.409",
    transform: "translate(-238.547 -279.261)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M297.05,374.7a9.241,9.241,0,0,1,3.974,2.624",
    transform: "translate(-243.283 -277.083)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M258.971,361.285s-1.052-4.366-3.369-5.864-11.577-.1-11.577-.1L227.24,345.26",
    transform: "translate(-200.566 -259.069)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M206.36,366c1.677.679,3.8,1.494,6.485,2.449a99.1,99.1,0,0,0,15.26,4.362s3.361,3.532,6.679,2.453c2.235-.73,6.4,2.589,7.9,1.906s-2.243-3.287-6.877-5.333",
    transform: "translate(-187.79 -271.76)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M317.231,267.846l9.924-11.356s-2.674-4.979-6-10.529-7.273-11.62-8.954-13.91c-4.681-2.286,1.94,25.848,1.94,25.848Z",
    transform: "translate(-251.529 -189.498)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M330,256.995c-4.23-9.206-15.159-25.095-15.159-25.095",
    transform: "translate(-254.168 -189.455)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M210.6,258.115l8.589,16.044,27.416-10.669,1.048-12.73c1.552-10.789-2.018-24.982-2.018-24.982l-17.853-3.838s-25.615,8.775-26,10.436S210.6,258.115,210.6,258.115Z",
    transform: "translate(-184.981 -183.43)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M210.6,258.115l8.589,16.044,27.416-10.669,1.048-12.73c1.552-10.789-2.018-24.982-2.018-24.982l-17.853-3.838s-25.615,8.775-26,10.436S210.6,258.115,210.6,258.115Z",
    transform: "translate(-184.981 -183.43)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M205.388,244.537c.656,1.4,3.881,8.651,5.045,10.479,1.552-13.168,1.013-14.616,2.2-15.307l5.511-3.213-2.88-1.758-.132-.6s-11.313,4.3-13.13,5.767C202,239.907,203.343,240.2,205.388,244.537Z",
    transform: "translate(-185.122 -190.819)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M331.5,265.917c1.2-.7-2.748.481-3.982,1.122-1.005.52-2.092,1.23-3.179.912s-1.657-1.6-1.94-2.717c-.893-3.493-.955-7.141-1.723-10.661a48.877,48.877,0,0,0-2.364-7.292s1.735,10.847.613,19.386l2.759,9.613S321.458,271.793,331.5,265.917Z",
    transform: "translate(-256.292 -198.909)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M189.62,287.275a21.311,21.311,0,0,0,16.168-3.881s-.206-12.361-1.4-15.493c-1.552-4.025-8.511-19.743-10.005-18.947-1.06.563-3.245,17.608-4.269,28.875A73.692,73.692,0,0,0,189.62,287.275Z",
    transform: "translate(-177.52 -199.954)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M189.62,287.275a21.311,21.311,0,0,0,16.168-3.881s-.206-12.361-1.4-15.493c-1.552-4.025-8.511-19.743-10.005-18.947-1.06.563-3.245,17.608-4.269,28.875A73.692,73.692,0,0,0,189.62,287.275Z",
    transform: "translate(-177.52 -199.954)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M231.74,289.59a19.793,19.793,0,0,1,.668,10.331",
    transform: "translate(-203.32 -224.825)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M208.77,323.128a9.637,9.637,0,0,1,7.075,2.053",
    transform: "translate(-189.265 -245.345)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M216.81,318.39a12.706,12.706,0,0,1,5.507,5.007",
    transform: "translate(-194.184 -242.482)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M196.3,251.473c1.894,3.574.966,8.034,1.448,12.051a17.21,17.21,0,0,0,1.587,6.3c.776,1.389,1.9,2.542,2.8,3.846a13.545,13.545,0,0,1,2.15,5.216c-2.41-2.43-5.045-4.979-8.406-5.6,1.6.815,3.823,2.686,3.252,3.276-1.118,1.056-2.5-1.386-3.648-.7a2.464,2.464,0,0,0-.928,1.4,11.643,11.643,0,0,0-.536,4.851l-5.138,2.371s3.1-32.822,5.076-35.515A6.377,6.377,0,0,1,196.3,251.473Z",
    transform: "translate(-177.094 -199.97)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M316.46,266a91.3,91.3,0,0,1,1.587,9.885",
    transform: "translate(-255.16 -210.348)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M194.748,344.2S204.924,340,206,338.378s-1.409-7.331-2.635-8.286-16.716,2-16.3,5.135,1.591,2.8,1.122,5.433C187.882,342.388,189.966,346.245,194.748,344.2Z",
    transform: "translate(-175.98 -249.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M201.714,342.435c1.432-1.106-3.563.706-5.371.6a2.08,2.08,0,0,1-1.6-.617,1.417,1.417,0,0,1-.1-1.347,3.062,3.062,0,0,1,.862-1.094,11.119,11.119,0,0,1,3.365-1.941c.536-.206,1.417-.388,1.164-1.11-.512-.776-1.941.019-2.837.411s-2.034.714-2.814.109a1.923,1.923,0,0,1-.442-2.22,4.234,4.234,0,0,1,1.615-1.766,1.7,1.7,0,0,0,.609-.586.528.528,0,0,0-.217-.726s-7.374,2.014-7.906,3.912.881,4.4.881,4.4-.877,3.144,1.358,4.824S198.4,345,201.714,342.435Z",
    transform: "translate(-176.508 -250.956)",
    fill: "#c9d6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M195.134,344.2s10.18-4.2,11.255-5.822-1.4-7.331-2.631-8.286-16.719,2-16.3,5.135,1.591,2.8,1.125,5.433C188.272,342.388,190.352,346.245,195.134,344.2Z",
    transform: "translate(-176.218 -249.586)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M328.47,309.12c-.1-.082-.19-.163-.279-.252-2.585-2.519-.947-5.7,1.164-7.9,1.941-2.034,5.4-5.131,8.321-5.48,1.316-.159,1.9.571,2.666,1.494.439.528.982.966,1.4,1.51a4.739,4.739,0,0,1-.171,5.9c-1.211,1.339-2.876,1.832-4.475,2.511-1.94.819-3.749,2.173-5.721,2.845A3.047,3.047,0,0,1,328.47,309.12Z",
    transform: "translate(-261.527 -228.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M336.858,306.927a16.981,16.981,0,0,0,4.16-4.048,3.962,3.962,0,0,0,.753-2.057,1.7,1.7,0,0,0-1.164-1.688,2.584,2.584,0,0,0-1.708.431l-1.622.846a.943.943,0,0,1-.633.155c-.31-.078-.45-.442-.47-.776a4.305,4.305,0,0,1,.928-2.457l.885-1.389a.345.345,0,0,0-.427-.035,13.94,13.94,0,0,0-7.677,4.906c-3.1,4.036-3.365,5.433-2.356,7.335S330.334,312,336.858,306.927Z",
    transform: "translate(-261.609 -228.68)",
    fill: "#c9d6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M328.47,309.12c-.1-.082-.19-.163-.279-.252-2.585-2.519-.947-5.7,1.164-7.9,1.941-2.034,5.4-5.131,8.321-5.48,1.316-.159,1.9.571,2.666,1.494.439.528.982.966,1.4,1.51a4.739,4.739,0,0,1-.171,5.9c-1.211,1.339-2.876,1.832-4.475,2.511-1.94.819-3.749,2.173-5.721,2.845A3.047,3.047,0,0,1,328.47,309.12Z",
    transform: "translate(-261.527 -228.442)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M231.108,130.875a7.087,7.087,0,0,1,1.615-5.294,10.518,10.518,0,0,1,4.657-3.151",
    transform: "translate(-202.909 -122.242)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M258.939,206.229c-.245,2.907-.338,9.757-.167,12.672L247.8,213.785a32.145,32.145,0,0,0-.124-10.005l11.255,2.449",
    transform: "translate(-213.073 -172.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M258.939,206.229c-.245,2.907-.338,9.757-.167,12.672L247.8,213.785a32.145,32.145,0,0,0-.124-10.005l11.255,2.449",
    transform: "translate(-213.073 -172.173)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M249,208.09s3.245,6.023,6.652,6.136c3.33.1,4.075-4.855,4.075-4.855s-1.382,2.624-2.884,2.565S249,208.09,249,208.09Z",
    transform: "translate(-213.881 -174.805)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M249.352,142.375s-14.174-3.035-18.183.671-3.008,7.836-3.008,7.836l.365,1.191a1.335,1.335,0,0,0-.3.031,2.8,2.8,0,0,0-1.793,3.411c.357,1.859,2.631,5.942,4.308,5.507a2.114,2.114,0,0,0,.543-.221c.559,1.68,1.052,3.074,1.32,3.64,1.067,2.251,9.19,6.935,11.1,6.287s6.9-10.355,7.149-12.7S249.352,142.375,249.352,142.375Z",
    transform: "translate(-200.028 -133.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M249.359,146.274c-1.715,1.82-4.552,2.045-7.013,1.6s-4.82-1.448-7.316-1.642a3.881,3.881,0,0,0-2.018.26,3.124,3.124,0,0,0-1.552,2.845,9.839,9.839,0,0,0,.776,3.307,9.86,9.86,0,0,1,.776,3.307c0,.528-.109,1.044-.128,1.552A17.949,17.949,0,0,0,234,163.933c1.665,4.638,5.95,6.508,10.246,8.15,0,0-1.552,1.285-4.618-.349-1.075-.57-5.135-3.307-5.135-3.307a6.334,6.334,0,0,1-2.647-3.493l-.776-2.437a1.715,1.715,0,0,1-2.3-.419c-1.114-1.254-2.783-3.551-2.643-5.36s.462-2.593,2.154-2.717a2.329,2.329,0,0,1,2.3,1.312l-1.323-7.871s3.97-3.761,6.823-3.2,9.314,1.6,10.933,1.184a16.63,16.63,0,0,0,2.232-.7Z",
    transform: "translate(-199.88 -135.553)",
    fill: "#c9d6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M249.359,146.3c-1.715,1.82-4.552,2.045-7.013,1.6s-4.82-1.448-7.316-1.642a3.881,3.881,0,0,0-2.018.26,3.124,3.124,0,0,0-1.552,2.845,9.839,9.839,0,0,0,.776,3.307,9.861,9.861,0,0,1,.776,3.307c0,.528-.109,1.044-.128,1.552A17.949,17.949,0,0,0,234,163.964c1.665,4.638,5.946,6.5,10.238,8.15a3.647,3.647,0,0,1-4.021-.1c-1.063-.594-5.725-3.551-5.725-3.551a6.334,6.334,0,0,1-2.647-3.493l-.776-2.437a1.715,1.715,0,0,1-2.3-.419c-1.114-1.254-2.783-3.551-2.643-5.36s.295-2.4,1.987-2.511a2.717,2.717,0,0,1,2.468,1.118l-1.323-7.871s3.97-3.761,6.823-3.2,9.314,1.6,10.933,1.184a16.63,16.63,0,0,0,2.232-.7Z",
    transform: "translate(-199.88 -135.584)",
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M263.934,175.054c0,.679-.248,1.234-.555,1.234s-.559-.551-.559-1.234.248-1.23.555-1.234S263.934,174.379,263.934,175.054Z",
    transform: "translate(-222.338 -153.688)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M279.794,174.244c0,.679-.248,1.234-.555,1.234s-.555-.555-.559-1.234.248-1.234.559-1.234S279.794,173.561,279.794,174.244Z",
    transform: "translate(-232.042 -153.192)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M272.234,199.943c-.958.834-1.93.367-2.864-1.376",
    transform: "translate(-226.346 -168.711)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M0,1.688a8.133,8.133,0,0,0,1.631-.522A7.649,7.649,0,0,0,3.493,0",
    transform: "matrix(-0.998, -0.07, 0.07, -0.998, 42.259, 19.119)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M0,0A5.643,5.643,0,0,0,1.878,1.471",
    transform: "translate(48.622 16.718) rotate(140)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M272.8,174.57q.167,1.2.342,2.41c.029.349,2.137,1.982,2.309,2.057a.528.528,0,0,1,.221.477,1.331,1.331,0,0,1-.427.815,5.651,5.651,0,0,1-1.354,1.091",
    transform: "translate(-228.444 -154.237)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M231.14,175.59a4.812,4.812,0,0,1,1.677,4.4",
    transform: "translate(-202.953 -154.861)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M230.55,180.227a.605.605,0,0,1,.442-.345,1.386,1.386,0,0,1,.578,0,1.257,1.257,0,0,1,.388.128.776.776,0,0,1,.318.415",
    transform: "translate(-202.592 -157.472)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M231.591,175.394s.846,2.422-1.25,2.961c-1.673.435-3.947-3.644-4.308-5.507a3.1,3.1,0,0,1,.64-2.69,2.231,2.231,0,0,1,1.164-.718c1.238-.295,2.472,1.207,3.252,2.441a11.041,11.041,0,0,0,.776,1.133",
    transform: "translate(-199.779 -151.068)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M233.575,161c.559,1.688,1.048,3.078,1.316,3.644,1.067,2.255,9.19,6.935,11.1,6.287s6.9-10.355,7.153-12.7-1.483-15.656-1.483-15.656-14.174-3.035-18.183.671-3.023,7.836-3.023,7.836",
    transform: "translate(-202.466 -133.853)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M278.628,127.74s2.189,4.556-.605,7.657-9.182.547-9.182.547",
    transform: "translate(-226.021 -125.491)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M247.408,122.261c-.885.361.629,1.913-1.257,2.391s-16.859-6.474-20.628,5.635c0,0-6.71,4.766-1.164,10.976a2.232,2.232,0,0,1,1.164-.718c1.2-.283,2.4,1.122,3.182,2.329.349,1.009.9,1.913,1.731,1.607,1.521-.551,1.009-2.457.388-3.85-.2-.442-.411-.831-.571-1.11-.955-1.661-2.367-3.493-1.723-5.507,1.289-2.418,5.2-2.8,8.926-1.847,6.163,1.572,13.374-.679,13.261-5.119S248.293,121.9,247.408,122.261Z",
    transform: "translate(-197.46 -122.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M246.78,124.113a.233.233,0,0,0-.035-.05c-.753-1.9-2.146-2.208-2.79-1.941-.885.361.629,1.913-1.257,2.391s-16.153-6.144-20.337,4.809a7.125,7.125,0,0,1,1.6-3.916,10.312,10.312,0,0,1,4.568-3.1.186.186,0,0,0-.124-.349,10.661,10.661,0,0,0-4.715,3.217,7.374,7.374,0,0,0-1.708,4.731,7.129,7.129,0,0,0-5.461,5.4.186.186,0,0,0,.14.221h.039a.186.186,0,0,0,.182-.144,6.776,6.776,0,0,1,5-5.084c-1.071.862-5.93,5.259-.966,10.82a2.232,2.232,0,0,1,1.164-.718c1.2-.283,2.4,1.122,3.182,2.329.349,1.009.9,1.913,1.731,1.607,1.521-.551,1.009-2.457.388-3.85-.2-.442-.411-.831-.571-1.11-.955-1.661-2.367-3.493-1.723-5.507,1.288-2.418,5.2-2.8,8.926-1.847a16.04,16.04,0,0,0,2.67.442.206.206,0,0,0,.1.1,15.524,15.524,0,0,0,5.076,1.009,5.639,5.639,0,0,0,4.312-1.607C248.988,128.821,246.8,124.16,246.78,124.113Zm-.912,7.615c-2.076,2.305-6.291,1.351-8.107.776,4.739.074,9.109-1.859,9.462-5.092A5.7,5.7,0,0,1,245.868,131.728Z",
    transform: "translate(-194.006 -121.946)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M236.39,139.356a6.189,6.189,0,0,1,5.321-2.86,24.493,24.493,0,0,1,6.21.974,11.864,11.864,0,0,0,6.248.113c2.007-.664,3.757-2.519,3.625-4.622",
    transform: "translate(-206.165 -128.685)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M235.35,137.232a6.039,6.039,0,0,1,2.639-3.279,13.622,13.622,0,0,1,6.085-2.282",
    transform: "translate(-205.529 -127.896)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M263.263,238.671c.155-.155,4.5-.951,4.5-.951s-.741,5.135-.388,6.986l-1.8.318s-1.746-3.229-3.124-4.234S263.263,238.671,263.263,238.671Z",
    transform: "translate(-221.834 -192.988)",
    fill: "#a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M271.9,253.593l.027,21.792,4.913,3.714,2.088-5.255-6.043-20.725Z",
    transform: "translate(-227.894 -202.486)",
    fill: "#a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M271.365,225.679l2.4-3.2a.388.388,0,0,1,.609-.047l3.07,3.07a.388.388,0,0,1,.066.485l-3.687,6.574a.388.388,0,0,1-.741-.093l-1.785-6.439A.415.415,0,0,1,271.365,225.679Z",
    transform: "translate(-227.517 -183.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M271.365,225.679l2.4-3.2a.388.388,0,0,1,.609-.047l3.07,3.07a.388.388,0,0,1,.066.485l-3.687,6.574a.388.388,0,0,1-.741-.093l-1.785-6.439A.415.415,0,0,1,271.365,225.679Z",
    transform: "translate(-227.517 -183.534)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M239.718,221.412l9.314,3.71a.388.388,0,0,1,.233.512l-2.391,6.761a.388.388,0,0,1-.574.221l-10.479-5.686a.388.388,0,0,1-.132-.6l3.559-4.785A.388.388,0,0,1,239.718,221.412Z",
    transform: "translate(-205.682 -182.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M239.718,221.412l9.314,3.71a.388.388,0,0,1,.233.512l-2.391,6.761a.388.388,0,0,1-.574.221l-10.479-5.686a.388.388,0,0,1-.132-.6l3.559-4.785A.388.388,0,0,1,239.718,221.412Z",
    transform: "translate(-205.682 -182.969)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x1: 2.756,
    y1: 9.163,
    transform: "translate(62.558 68.272)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M310.3,330.37l-19.017,7.987a1.164,1.164,0,0,0-.19,2.034l14.682,9.761,9.551-9.536Z",
    transform: "translate(-239.324 -249.958)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M310.451,345.122l-2.286.9,1.226.865,2.29-.9Zm0,0-2.286.9,1.226.865,2.29-.9Zm0,0-2.286.9,1.226.865,2.29-.9Zm1.552,1.1-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm-5.131,2.006,1.354.928,2.441-.955-1.331-.935ZM312,346.232l-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm0,0-2.29.893,1.331.939,2.294-.9Zm1.661,1.164-2.29.9,1.525,1.071,2.29-.9Zm.388-.147,1.529,1.075.109-.047.427-1.832Zm-.326-.229-.388.147.326.229.388-.147Zm-.047.388-2.29.9,1.525,1.071,2.29-.9Zm0,0-2.29.9,1.525,1.071,2.29-.9Zm0,0-2.29.9,1.525,1.071,2.29-.9Zm2.236-1.234.233.163.066-.276Zm-2.189.858-.388.148.326.229.388-.147Zm.858-1.793-2.193.846,1.331.935,2.189-.858Zm-.858,1.793-.388.148.326.229.388-.147Zm-.047.388-2.29.9,1.525,1.071,2.29-.9Zm.047-.388-.388.148.326.229.388-.147Zm-.047.388-2.29.9,1.525,1.071,2.29-.9Zm0,0-2.29.9,1.525,1.071,2.29-.9Zm.388-.147,1.529,1.075-.388.144.33.229-2.294.9-.326-.233-.388.148.33.229-2.41.916,1.164.807,2.379-.931.334.233-2.364.931,1.552,1.067.943.644.256-1.114.252-1.075.081-.345.1-.427.093-.388.31-1.335v-.062l.07-.287.023-.109.427-1.832Zm-.388.147-2.29.9,1.525,1.071,2.29-.9Zm.047-.388-.388.148.326.229.388-.147Zm-.047.388-2.29.9,1.525,1.071,2.29-.9Zm.047-.388-.388.148.326.229.388-.147Zm-.047.388-2.29.9,1.525,1.071,2.29-.9Zm.047-.388-.388.148.326.229.388-.147Zm-.047.388-2.29.9,1.525,1.071,2.29-.9Zm.047-.388-.388.148.326.229.388-.147Zm1.23-1.94,1.269.893.357-1.529Zm-1.94-.951-2.193.858-.326-.233,2.189-.854.33.229.388-.147-.33-.229,2.329-.9-1.164-.827-2.309.912-.388.144-2.208.869-.388.147-2.282.9-.388.148-2.515.99,1.164.8,2.5-.978.33.233-2.492.974,1.25.854,2.472-.962.326.229.388-.148-.326-.229,2.29-.9.326.233.388-.147-.33-.233,2.189-.858Zm-4.851,1.9-.334-.229,2.294-.9.326.229Zm7.587-3.326-.388.148.33.229.388-.147Zm.326.229.73.512.2-.873Zm-1.5-1.056,1.164.827,1.347-.528.334-1.424Zm-.862,5.142-.388.147.326.229.388-.148Zm.528-2.026-1.226-.862-2.193.858-.388.144,1.23.865.326.233.388-.148-.33-.233Zm.33.233-2.181.85,1.331.935,2.189-.858Zm2.15-1.432-1.013-.714-2.329.9,1.226.865-.369.144.326.233.388-.144-.326-.233,2.045-.8Zm-3.008,3.225,2.189-.858-1.331-.935-2.181.85Zm.528-2.026-1.226-.862-2.193.858-.388.144,1.23.865.326.233.388-.148-.33-.233Zm-.574,2.4-2.29.9,1.525,1.071,2.29-.9Zm0,0-2.29.9,1.525,1.071,2.29-.9Zm-1.661-1.164-2.29.893,1.331.939,2.294-.9Zm-1,2.2-2.449.947,1.552,1.06,2.406-.939Zm.039-.388-.388.144.334.229.369-.144Zm2.62-.668-2.29.9,1.525,1.071,2.29-.9Zm.388-.147,1.529,1.075.109-.047.427-1.832Zm-.326-.229-.388.148.326.229.388-.147Zm-3.279-1.89-2.286.9,1.226.865,2.29-.9Zm0,0-2.286.9,1.226.865,2.29-.9Zm0,0-2.286.9,1.226.865,2.29-.9Z",
    transform: "translate(-247.389 -256.315)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M329.77,323.521,335,300.67a2.752,2.752,0,0,1,1.615-1.921L364.7,286.908a.753.753,0,0,1,1.013.908l-6.741,22.743Z",
    transform: "translate(-263.304 -223.327)",
    fill: "#cdd4d9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M379.588,326.793a2.2,2.2,0,1,1-2.527,1.017A1.957,1.957,0,0,1,379.588,326.793Z",
    transform: "translate(-292.029 -247.523)",
    fill: "#263238"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpgAccountIcon);
export default __webpack_public_path__ + "static/media/OPG_account-icon.aeb58ec4d69b9519c2ad8fd82d5c6d69.svg";
export { ForwardRef as ReactComponent };